export default __webpack_public_path__ + "static/media/mandiri.fa12cd53.png";